<template>
  <div class="add-house">


    <h1 v-if="type" @click="selectXq()">{{v_name}}<i></i></h1>
    <h1 v-else>{{v_name}}</h1>


    <div class="community-tit">
        <span>楼栋</span>
        <span>单元</span>
        <span>房间</span>
    </div>

    <div class="community-list">

        <!-- <ul class="building">
            <li v-for="(item, bindex) in buildings" @click="bindActive(bindex, 'building',item.building_id)" :class="{active: bnowIdx == bindex}">{{item.building_name}}</li>
        </ul> -->
        <div class="building">
            <span v-for="(item, bindex) in buildings" @click="bindActive(bindex, 'building',item.building_id,item.building_name)" :class="{active: bnowIdx == bindex}">{{item.building_name}}</span>
        </div>
        <ul class="cell">

            <li v-for="(item, cindex) in cells" @click="bindActive(cindex, 'cell',item.unit_id,item.unit_name)" :class="{active: cnowIdx == cindex}"><span>{{item.unit_name}}<i></i></span></li>

        </ul>
        <ul class="room">
            <li v-for="(item, rindex) in rooms" @click="bindActive(rindex, 'room',item.room_id,item.room_name)" :class="{active: rnowIdx == rindex}">{{item.room_name}}</li>
        </ul>
    </div>

    <div class="bind-house">
      <button @click="bindHouse()">绑定房间</button>
    </div>


    <mt-popup v-model="popupVisible">
        <div class="communities">
            <div class="commu-item" v-for="(item, index) in communities" @click="tabVillage(item.v_token)">
                {{item.v_name}}
            </div>
        </div>
    </mt-popup>

  </div>
</template>
<script>
import {MessageBox} from 'mint-ui';
export default {
  data () {
    return {
        communities: [], // 小区列表
        buildings: [], // 栋楼列表
        cells: [], // 单元列表
        rooms: [],  // 房间列表
        bnowIdx: 0, // 楼栋点击索引
        cnowIdx: 0, // 单元点击索引
        rnowIdx: 0, // 房间点击索引
        room_id:0,
        building_id:0,
        unit_id:0,
        v_token:"",    //注意: 指选择的小区
        v_name:"",
        v_id:0,
        type:true, //true:物业 false:小区
        popupVisible: false, // 选择小区显示控制,
        userId:'', //用户id
        property_token:'',
        room_name:0,
        building_name:0,
        unit_name:0
    }
  },
  created(){
   
        //获取房屋信息
        this.v_token = this.$route.query.v_token;
        this.userId = this.$route.query.userId;
        this.property_token = this.$route.query.property_token;
        
        this.type = this.property_token && this.property_token != 'undefined' ? true : false;
        
        let json = JSON.stringify({"v_token":this.v_token,"is_share":true});
                        
        this.axios.get('/jmobile/MyVillageRoom/getVillageInfo/json/'+json).then((res)=>{
             if(res.data.status == '1'){
                 this.v_name = res.data.data.village_name;
                 this.v_id = res.data.data.id;
                 this.getLy();
             }else{
                 this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'2000'
                 });
             }
        }).catch((res)=>{
                 this.$toast({
                    message:'网络错误',
                    position:'bottom',
                    duration:'2000'
                 });
        });

       
        
  },
  methods: {
    tabVillage(v_token){
        this.v_token = v_token;
        let json = JSON.stringify({"v_token":v_token,"is_share":true});
        this.axios.get('/jmobile/MyVillageRoom/getVillageInfo/json/'+json).then((res)=>{
            if(res.data.status == '1'){
                this.v_name = res.data.data.village_name;
                this.v_id = res.data.data.id;
                this.getLy();

            }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'2000'
                });
            }
            this.popupVisible = false;
        }).catch((res)=>{
             this.$toast({
                 message:'网络错误',
                 position:'bottom',
                 duration:'2000'
             });
        });
    },
    getLy(){

         this.$indicator.open();
         let ly_json = JSON.stringify({'village_id':this.v_id,'is_share':true});
         this.axios.get('/jmobile/register/getly/json/'+ly_json).then((res)=>{
             
              if(res.data.status == '1'){
                this.buildings = res.data.data;
                this.getCell(this.buildings[0]['building_id'],'1');
                this.building_id = this.buildings[0]['building_id'];
                this.building_name = this.buildings[0]['building_name'];
              }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'2000'
                });
              }
             this.$indicator.close();
         }).catch((response)=>{
             this.$indicator.close();
             this.$toast({
                message:'网络错误',
                position:'bottom',
                duration:'2000'
             })
         });
    },
    //获取单元
    getCell(building_id,type){
    
            this.$indicator.open();
            var json = JSON.stringify({"building_id":""+building_id+"","is_share":true});
          
            this.axios.get('/jmobile/Register/getdy/json/'+json).then((res)=>{
                this.$indicator.close();
                if(res.data.status == '1'){
                    this.cells = res.data.data;
                    //每获取一次房间，都默认获取第一个单元的所有房间
                    this.getRoom(this.cells[0]['unit_id']);
                    this.unit_id = this.cells[0]['unit_id'];
                    this.unit_name = this.cells[0]['unit_name'];
                }else{
                    this.cells = [];
                    this.rooms = [];
                    this.$toast({
                        message:'暂无数据',
                        position:'bottom',
                        duration:'1000'
                    });
                }
                
            }).catch((response)=>{
                this.$toast({
                    message:'网络错误',
                    position:'bottom',
                    duration:'1000'
                });
            });
    },
    getRoom(unit_id){
        this.$indicator.open();
        var json = JSON.stringify({"unit_id":""+unit_id+"","is_share":true});

        this.axios.get('/jmobile/Register/getshi/json/'+json).then((res)=>{
            this.$indicator.close();
            if(res.data.status == '1'){
                this.rooms = res.data.data;
                this.room_id = this.rooms[0]['room_id'];
                this.room_name = this.rooms[0]['room_name'];
            }else{
                this.$toast({
                    message:'暂无数据',
                    position:'bottom',
                    duration:'3000'
                })
            }
            
        }).catch((response)=>{
            this.$indicator.close();
            this.$toast({
                message:'网络错误',
                position:'bottom',
                duration:'3000'
            })
        })

    },
    // 绑定房间
    bindHouse () {
        var title = this.building_name+'-'+this.unit_name+'-'+this.room_name;
        MessageBox({
            title: title,
            message: '确定绑定此房间?',
            showCancelButton:true
        }).then(action=>{
           if(action == 'confirm'){
            var json = JSON.stringify({"user_id":this.userId,"user_uid":this.UserId,"token":"testxiaoqu1","village_token":this.v_token,"building_id":""+this.building_id+"","unit_id":""+this.unit_id+"","room_id":""+this.room_id+"","is_share":true})
            this.axios.get('/jmobile/MyVillageRoom/add/json/'+json).then((res)=>{
                if(res.data.status == '1'){
                    //this.$router.push({name:'MyHouse',query:{userId:this.userId}});
                    if(this.$route.query.jump && this.$route.query.jump != 'undefined'){   
                        //jump参数可指定添加完房屋跳到的主件, token指级别, fee_token指选择房间所在的小区token
                        this.$router.push({name: this.$route.query.jump, query: {token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,room_id:this.room_id,fee_token:this.v_token}});
                    }else{
                        //返回我的房间列表
                        if(this.$route.query.city_id && this.$route.query.city_id != 'undefined'){
                            history.go(-2);
                        }else{
                            history.go(-1);
                        }
                    }
                }else{
                    this.$toast({
                        message:res.data.info,
                        position:'bottom',
                        duration:'1000'
                    })
                }
            }).catch((response)=>{
                this.$toast({
                    message:'网络错误',
                    position:'bottom',
                    duration:'1000'
                })
            })
           }
        })
    },
    // 控制那个楼选active
    bindActive (idx, tit, id, name) {
        
        switch (tit) {
            case 'building': 
                this.bnowIdx = idx;
                this.getCell(id);
                this.building_id = id;
                this.building_name = name;
                break;
            case 'cell': 
                this.cnowIdx = idx;
                this.getRoom(id);
                this.unit_id = id;
                this.unit_name = name;
                break;
            case 'room': 
                this.rnowIdx = idx;
                this.room_id = id;
                this.room_name = name;
                break;
        }
    },
    selectXq(){

        let json={property_token:this.$route.query.property_token};
            json=JSON.stringify(json);

        this.axios.get('/jmobile/MyVillageRoom/getVillageByProperty/json/'+json).then((res)=>{
             if(res.data.status == '1'){
                    this.communities = res.data.data;
             }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'2000'
                });
             }
        }).catch((res)=>{
            this.$toast({
                message:'参数错误',
                position:'bottom',
                duration:'2000'
            })
        })

        // 选择小区
        this.popupVisible = true;
    }
  }
}
</script>
<style lang="less">
.add-house{
    position: relative;
    box-sizing: border-box;
    padding-top: 12px;
    width: 100%;
    height: 100%;
    background-color: #fff;
    h1{
        margin: 0 auto 12px;
        width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background-color: #ffaf14;
        color: #fff;
        border-radius: 15px;
        font-size: 14px;
        font-weight: normal;
        i{
            display: inline-block;
            margin-left: 5px;
            vertical-align: middle;
            width: 13px;
            height: 10px;
            background-image: url(../assets/arrow_down@2x.png);
            background-size: 100%;
            background-repeat: no-repeat;
        }
    }
    .community-tit{
        display: flex;
        border-top: 1px solid #ececec;
        span{
            flex: 1;
            text-align: center;
            height: 45px;
            line-height: 45px;
        }
    }
    .community-list{
        display: flex;
        position: absolute;
        top: 101px;
        left: 0;
        bottom: 70px;
        width: 100%;
        border-top: 1px solid #ececec;
        border-bottom: 1px solid #ececec;
        .building{
            flex: 1;
            height: 100%;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            span{
                display: block;
                padding: 0 14px;
                height: 55px;
                line-height: 55px;
                color: #666;
                &.active{
                    color: #fff;
                    background-image: url(../assets/select@2x.png);
                    background-size: 100% 100%;
                }
            }
        }
        ul{
            flex: 1;
            height: 100%;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            font-size: 14px;
            li{
                position: relative;
                border-bottom: 1px solid #ececec;
                box-sizing: border-box;
                padding: 0 14px;
                min-height: 55px;
                color: #666;
                &.active{
                    color: #ffaf14;
                }
            }
            &.room{
                line-height: 55px;
            }
            &.cell{
                border-left: 1px solid #ececec;
                border-right: 1px solid #ececec;
                li{
                    display: flex;
                    padding-right: 0;
                    align-items: center;
                    span{
                        padding-right: 13px;
                        position: relative;
                        display: block;
                        width: 100%;
                        i{
                            position: absolute;
                            right: 2px;
                            top: 0px;
                            width: 14px;
                            height: 100%;
                            background-image: url(../assets/arrow_right_normal@2x.png);
                            background-size: 14px 14px;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                    }
                    &.active{
                        i{
                            background-image: url(../assets/arrow_right_select@2x.png);
                        }
                    }
                }
            }
        }
    }
    .bind-house{
        position: absolute;
        box-sizing: border-box;
        height: 45px;
        bottom: 15px;
        left: 0;
        padding: 0 16px 0 14px;
        width: 100%;
        button{
            width: 100%;
            height: 45px;
            line-height: 45px;
            text-align: center;
            color: #fff;
            background-color: #ffaf14;
            border-radius: 5px;
            font-size: 18px;
        }
    }
    .mint-popup{
        width: 70%;
        max-height: 80%;
        min-height: 50px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        .communities{
            .commu-item{
                height: 50px;
                line-height: 50px;
                text-align: center;
                border-top: 1px solid #ececec;
            }
        }
    }
    
}
</style>




// WEBPACK FOOTER //
// src/components/SelectCommunity.vue